module.exports = __webpack_public_path__ + "static/seb-richards-c2086223033a20cddf34c371d2f230be.jpg";